export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
            如果你有爆料线索、内容投稿或商务合作需求，欢迎通过以下方式与我们取得联系。我们珍视每一位吃瓜群众的贡献，期待你的来信。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-50 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">爆料投稿</p>
              <p className="text-xs text-foreground-400">news@51chigua.com</p>
            </div>

            <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-briefcase-line text-accent-500 text-lg"></i>
              </div>
              <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">商务合作</p>
              <p className="text-xs text-foreground-400">biz@51chigua.com</p>
            </div>

            <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-secondary-100 flex items-center justify-center">
                <i className="ri-question-line text-secondary-600 text-lg"></i>
              </div>
              <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">问题反馈</p>
              <p className="text-xs text-foreground-400">help@51chigua.com</p>
            </div>
          </div>

          <p className="text-xs text-foreground-400">
            <i className="ri-time-line mr-1"></i>
            工作日 9:00 - 18:00，我们会在24小时内回复您的来信
          </p>
        </div>
      </div>
    </section>
  );
}